import { OfferRequestReportStatus } from '@houzy/schemas/offer-request-management';
import type {
    PartnerCockpitOfferRequest,
    PartnerCockpitOfferRequestSource,
    PartnerCockpitLeadStatus,
} from '@houzy/schemas/partner-cockpit/offer-requests';

export type OfferRequestCapabilities = {
    canEngageCustomer: boolean;
};

export function offerRequestCapabilities(
    source: PartnerCockpitOfferRequestSource | undefined,
): OfferRequestCapabilities {
    return {
        canEngageCustomer: source === 'matching',
    };
}

// The report status tracks the partner's own work, of which there is none while the customer has yet to
// answer, nor once they have said no.
const LEAD_STATUSES_TRACKING_PARTNER_WORK: ReadonlySet<PartnerCockpitLeadStatus> = new Set(['active', 'engaged']);

export function isOfferRequestStatusLocked(offerRequest: PartnerCockpitOfferRequest): boolean {
    return (
        !LEAD_STATUSES_TRACKING_PARTNER_WORK.has(offerRequest.leadStatus) ||
        offerRequest.status === OfferRequestReportStatus.RequestRejected
    );
}
